import React, { Component } from 'react'
import './index.less'
interface PayBarProps {
    price: string
    onClick?: () => void
}
export default class PayBar extends Component<PayBarProps> {
    render() {
        return (
            <div className='pay-bar-content'>
                <div className='pay-bar-left'>
                    <span className='pay-bar-title'>付款</span>
                    <span className='pay-bar-price'>￥{this.props.price}</span>
                </div>
                <div className='pay-bar-right' onClick={this.props.onClick}>
                    <span className='pay-bar-button-title'>去支付</span>
                    <img className='pay-bar-button-img' src="/public/assets/img/arrow_right.png" alt="" />
                </div>
            </div>
        )
    }
}